export default {
  namespaced: true,
  state: {
    demande: null,
    produit: null,
    fournisseur: null,
    typesDemandes: null,
    produitsFournisseur: null,
  },
  getters: {},
  mutations: {
    SET_DEMANDE(state, payload) {
      state.demande = payload;
    },
    SET_PRODUIT(state, payload) {
      state.produit = payload;
    },
    SET_FOURNISSEUR(state, payload) {
      state.fournisseur = payload;
    },
    ADD_IMAGE_GENERAL(state, payload) {
      state.produit.images.push(payload);
    },
    REMOVE_IMAGE_GENERAL(state, payload) {
      state.produit.images.splice(payload, 1);
    },
    CLEAR_IMAGES_GENERAL(state) {
      state.produit.images.splice(0, state.produit.images.length);
    },
    MOVE_IMAGE_GENERAL_UP(state, index) {
      let img = state.produit.images.splice(index, 1)[0];
      state.produit.images.splice(index - 1, 0, img);
    },
    MOVE_IMAGE_GENERAL_DOWN(state, index) {
      let img = state.produit.images.splice(index, 1)[0];
      state.produit.images.splice(index + 1, 0, img);
    },
    ADD_IMAGE_DESCRIPTION(state, payload) {
      state.produit.imagesDescription.push(payload);
    },
    REMOVE_IMAGE_DESCRIPTION(state, payload) {
      state.produit.imagesDescription.splice(payload, 1);
    },
    CLEAR_IMAGES_DESCRIPTION(state) {
      state.produit.imagesDescription.splice(
        0,
        state.produit.imagesDescription.length
      );
    },
    MOVE_IMAGE_DESCRIPTION_UP(state, index) {
      let img = state.produit.imagesDescription.splice(index, 1)[0];
      state.produit.imagesDescription.splice(index - 1, 0, img);
    },
    MOVE_IMAGE_DESCRIPTION_DOWN(state, index) {
      let img = state.produit.imagesDescription.splice(index, 1)[0];
      state.produit.imagesDescription.splice(index + 1, 0, img);
    },
    ADD_IMAGE_REFERENCES(state, payload) {
      state.produit.imagesReferences.push(payload);
    },
    REMOVE_IMAGE_REFERENCES(state, payload) {
      state.produit.imagesReferences.splice(payload, 1);
    },
    CLEAR_IMAGES_REFERENCES(state) {
      state.produit.imagesReferences.splice(
        0,
        state.produit.imagesReferences.length
      );
    },
    MOVE_IMAGE_REFERENCES_UP(state, index) {
      let img = state.produit.imagesReferences.splice(index, 1)[0];
      state.produit.imagesReferences.splice(index - 1, 0, img);
    },
    MOVE_IMAGE_REFERENCES_DOWN(state, index) {
      let img = state.produit.imagesReferences.splice(index, 1)[0];
      state.produit.imagesReferences.splice(index + 1, 0, img);
    },
    ADD_DOCUMENT(state, payload) {
      state.produit.documents.push(payload);
    },
    REMOVE_DOCUMENT(state, payload) {
      state.produit.documents.splice(payload, 1);
    },
    CLEAR_DOCUMENTS(state) {
      state.produit.documents.splice(0, state.produit.documents.length);
    },
    MOVE_DOCUMENT_UP(state, index) {
      let img = state.produit.documents.splice(index, 1)[0];
      state.produit.documents.splice(index - 1, 0, img);
    },
    MOVE_DOCUMENT_DOWN(state, index) {
      let img = state.produit.documents.splice(index, 1)[0];
      state.produit.documents.splice(index + 1, 0, img);
    },
    ADD_REFERENCE(state, payload) {
      state.produit.references.push(payload);
    },
    ADD_REFERENCES(state, payload) {
      state.produit.references = state.produit.references.concat(payload);
    },
    UPDATE_REFERENCE(state, payload) {
      const { index, ref } = payload;
      state.produit.references.splice(index, 1, ref);
    },
    REMOVE_REFERENCE(state, payload) {
      state.produit.references.splice(payload, 1);
    },
    CLEAR_REFERENCES(state) {
      state.produit.references.splice(0, state.produit.references.length);
    },
    MOVE_REFERENCE_UP(state, index) {
      let ref = state.produit.references.splice(index, 1)[0];
      state.produit.references.splice(index - 1, 0, ref);
    },
    MOVE_REFERENCE_DOWN(state, index) {
      let ref = state.produit.references.splice(index, 1)[0];
      state.produit.references.splice(index + 1, 0, ref);
    },
    SET_TYPES_DEMANDES(state, payload) {
      state.typesDemandes = payload;
    },
    SET_PRODUITS_FOURNISSEUR(state, payload) {
      state.produitsFournisseur = payload;
    },
    SET_DOMAINES(state, payload) {
      state.produit.domaines = payload;
    },
  },
  actions: {
    clear({ commit }) {
      commit("SET_PRODUIT", null);
      commit("SET_DEMANDE", null);
      commit("SET_FOURNISSEUR", null);
      commit("SET_PRODUITS_FOURNISSEUR", null);
      commit("SET_TYPES_DEMANDES", null);
    },
    setDemandeEnCours({ commit }, payload) {
      commit("SET_DEMANDE", payload);
    },
    setProduitDemandeEnCours({ commit }, payload) {
      commit("SET_PRODUIT", payload);
    },
    setFournisseurDemandeEnCours({ commit }, payload) {
      commit("SET_FOURNISSEUR", payload);
    },
    addImage({ commit }, { kind, payload }) {
      let mutationName = "ADD_IMAGE_GENERAL";
      switch (kind.toLowerCase()) {
        case "references":
          mutationName = "ADD_IMAGE_REFERENCES";
          break;
        case "description":
          mutationName = "ADD_IMAGE_DESCRIPTION";
          break;
        case "general":
          break;
        default:
          throw new Error("type image inconnu");
      }
      commit(mutationName, payload);
    },
    removeImage({ commit }, { kind, index }) {
      let mutationName = "REMOVE_IMAGE_GENERAL";
      switch (kind.toLowerCase()) {
        case "references":
          mutationName = "REMOVE_IMAGE_REFERENCES";
          break;
        case "description":
          mutationName = "REMOVE_IMAGE_DESCRIPTION";
          break;
        case "general":
          break;
        default:
          throw new Error("type image inconnu");
      }
      commit(mutationName, index);
    },
    clearImages({ commit }, kind) {
      let mutationName = "CLEAR_IMAGES_GENERAL";
      switch (kind.toLowerCase()) {
        case "references":
          mutationName = "CLEAR_IMAGES_REFERENCES";
          break;
        case "description":
          mutationName = "CLEAR_IMAGES_DESCRIPTION";
          break;
        case "general":
          break;
        default:
          throw new Error("type image inconnu");
      }
      commit(mutationName);
    },
    moveImageUp({ commit }, { kind, index }) {
      let mutationName = "MOVE_IMAGE_GENERAL_UP";
      switch (kind.toLowerCase()) {
        case "references":
          mutationName = "MOVE_IMAGE_REFERENCES_UP";
          break;
        case "description":
          mutationName = "MOVE_IMAGE_DESCRIPTION_UP";
          break;
        case "general":
          break;
        default:
          throw new Error("type image inconnu");
      }
      commit(mutationName, index);
    },
    moveImageDown({ commit }, { kind, index }) {
      let mutationName = "MOVE_IMAGE_GENERAL_DOWN";
      switch (kind.toLowerCase()) {
        case "references":
          mutationName = "MOVE_IMAGE_REFERENCES_DOWN";
          break;
        case "description":
          mutationName = "MOVE_IMAGE_DESCRIPTION_DOWN";
          break;
        case "general":
          break;
        default:
          throw new Error("type image inconnu");
      }
      commit(mutationName, index);
    },
    moveImageToOtherCollection({ commit, state }, { kind, index, to }) {
      let delMutationName = "REMOVE_IMAGE_GENERAL";
      let appendMutationName = "ADD_IMAGE_GENERAL";
      let image = null;

      switch (kind.toLowerCase()) {
        case "references":
          delMutationName = "REMOVE_IMAGE_REFERENCES";
          image = state.produit.imagesReferences[index];
          break;
        case "description":
          delMutationName = "REMOVE_IMAGE_DESCRIPTION";
          image = state.produit.imagesDescription[index];
          break;
        case "general":
          image = state.produit.images[index];
          break;
        default:
          throw new Error("type image inconnu");
      }

      switch (to.toLowerCase()) {
        case "references":
          appendMutationName = "ADD_IMAGE_REFERENCES";
          break;
        case "description":
          appendMutationName = "ADD_IMAGE_DESCRIPTION";
          break;
        case "general":
          break;
        default:
          throw new Error("type image inconnu");
      }

      commit(appendMutationName, image);
      commit(delMutationName, index);
    },
    addDocument({ commit }, payload) {
      commit("ADD_DOCUMENT", payload);
    },
    removeDocument({ commit }, index) {
      commit("REMOVE_DOCUMENT", index);
    },
    clearDocuments({ commit }) {
      commit("CLEAR_DOCUMENTS");
    },
    moveDocumentUp({ commit }, index) {
      commit("MOVE_DOCUMENT_UP", index);
    },
    moveDocumentDown({ commit }, index) {
      commit("MOVE_DOCUMENT_DOWN", index);
    },
    addReference({ commit }, payload) {
      commit("ADD_REFERENCE", payload);
    },
    addReferences({ commit }, payload) {
      commit("ADD_REFERENCES", payload);
    },
    updateReference({ commit }, payload) {
      commit("UPDATE_REFERENCE", payload);
    },
    removeReference({ commit }, index) {
      commit("REMOVE_REFERENCE", index);
    },
    clearReferences({ commit }) {
      commit("CLEAR_REFERENCES");
    },
    moveReferenceUp({ commit }, index) {
      commit("MOVE_REFERENCE_UP", index);
    },
    moveReferenceDown({ commit }, index) {
      commit("MOVE_REFERENCE_DOWN", index);
    },
    setTypesDemandes({ commit }, payload) {
      commit("SET_TYPES_DEMANDES", payload);
    },
    setProduitsFournisseur({ commit }, payload) {
      commit("SET_PRODUITS_FOURNISSEUR", payload);
    },
    unsetTypesDemandes({ commit }) {
      commit("SET_TYPES_DEMANDES", null);
    },
    unsetProduitsFournisseur({ commit }) {
      commit("SET_PRODUITS_FOURNISSEUR", null);
    },
    setDomainesProduitEdite({ commit }, payload) {
      commit("SET_DOMAINES", payload);
    },
  },
};
